// CLUBWISE TEST RECORDS (2026-10-30, Scott; both brands).
//
// ClubWise staff create test people in a club's records, and their email address
// ends `@clubwise.com`. Those rows are not leads and must not be counted.
//
// ⚠️ ONLY THE EMAIL DOMAIN IS READ. The browser decides this per row from the Email
// column and keeps nothing else from it: the address itself is never stored, sent,
// shown or logged, and a row is marked with a single boolean.

const TEST_EMAIL_SUFFIX = '@clubwise.com';

/** True when an email cell ends `@clubwise.com` (case-insensitive, whitespace trimmed). */
export function isClubwiseTestEmail(raw: unknown): boolean {
  if (typeof raw !== 'string') return false;
  return raw.trim().toLowerCase().endsWith(TEST_EMAIL_SUFFIX);
}
